import { createSlice } from "@reduxjs/toolkit";
import { fetchUsersData, fetchUserRoles, deleteUser } from "../Thunks/usersThunk";
import { addAsyncResourceThunk, isSupersededRequestPayload } from "../helpers/asyncResource";

const initialState = {
  data: null,
  loading: false,
  error: null,
  /** Cached GET /users/all response — reused by filter dropdowns across screens */
  allListLoaded: false,
  allListData: null,
  /** Cached GET /users/roles — reused for role dropdowns */
  userRolesLoaded: false,
  userRolesData: null,
  userRolesLoading: false,
  userRolesError: null,
};

export const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    clearUsers: (state) => {
      state.data = null;
      state.error = null;
      state.allListLoaded = false;
      state.allListData = null;
      state.userRolesLoaded = false;
      state.userRolesData = null;
      state.userRolesLoading = false;
      state.userRolesError = null;
    },
  },
  extraReducers: (builder) => {
    addAsyncResourceThunk(builder, fetchUsersData, {
      onFulfilled: (state, action) => {
        state.data = action.payload;
        if (action.meta?.arg?.getAll === true) {
          state.allListLoaded = true;
          state.allListData = action.payload;
        }
      },
    });
    builder
      .addCase(fetchUserRoles.pending, (state) => {
        state.userRolesLoading = true;
        state.userRolesError = null;
      })
      .addCase(fetchUserRoles.fulfilled, (state, action) => {
        state.userRolesLoading = false;
        state.userRolesError = null;
        state.userRolesLoaded = true;
        state.userRolesData = action.payload;
      })
      .addCase(fetchUserRoles.rejected, (state, action) => {
        if (isSupersededRequestPayload(action.payload)) return;
        state.userRolesLoading = false;
        state.userRolesError = action.payload ?? action.error?.message ?? "Failed to fetch roles";
      })
      .addCase(deleteUser.fulfilled, (state) => {
        state.allListLoaded = false;
        state.allListData = null;
      });
  },
});

export const { clearUsers } = usersSlice.actions;
export const selectUsersData = (state) => state.users.data;
export const selectUsersLoading = (state) => state.users.loading;
export const selectUsersError = (state) => state.users.error;
export const selectUsersAllListData = (state) => state.users.allListData;
export const selectUsersAllListLoaded = (state) => state.users.allListLoaded;
export const selectUserRolesLoading = (state) => state.users.userRolesLoading;
export const selectUserRolesError = (state) => state.users.userRolesError;

export default usersSlice.reducer;
